import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { Router } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { LoadingScreenService } from './loading-screen.service';
import { finalize } from "rxjs/operators";
import { MessageUtils } from "@utils/message.utils";
import { RestService } from './rest.service';
import { MatDialog } from '@angular/material/dialog';
import { ErrorModalComponent } from '@common/error-modal/error-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { SmioneIntroScreensComponent } from '@common/carousels/carousels.component';

@Injectable()
export class SmiOneHttpInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  smioneLoginRestrictmodalTrue: boolean = true; 
  showAlternateIntroPopVal: boolean = false; 


  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private loadingService: LoadingScreenService,
    private restService: RestService,
    private dialog: MatDialog,
    private translate: TranslateService,
    ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tokens = this.authenticationService.getToken();
    const  preLoginToken =  sessionStorage.getItem("pre-login-token");
    request = request.clone({setHeaders: {'Cache-Control': 'no-cache', Pragma: 'no-cache','Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'}}); 
    
    if (request.headers.getAll("isPreLogin") && preLoginToken)
    {
      request = request.clone({setHeaders: { 'Authorization':'Bearer ' + preLoginToken}});        
    }
    else if (request.headers.getAll("isPreLogin") ||  request.url.includes('app.config.json') ||  request.url.includes('assets'))
    {
            
    }  
   else if (tokens) {
      if(!sessionStorage.getItem("token") || (sessionStorage.getItem("token") == "null"))
      {
        localStorage.removeItem("token");
        this.restService.generateNewIDMLogoutUrl();
      }
      else if (tokens != sessionStorage.getItem("token")) 
      {
        localStorage.removeItem("token");
        this.restService.generateNewIDMLogoutUrl(); 
      }
      else
        request = request.clone({setHeaders: {'Authorization':'Bearer ' + tokens}});        
    }
    if(localStorage.getItem("DeviceID")&& localStorage.getItem("DeviceID")!="")
    {
      request = request.clone({setHeaders: {'Device': localStorage.getItem("DeviceID")}});
    }
    if ( request.url.includes('freshdesk')) {      
      request = request.clone({ headers: request.headers.set('Authorization', 'Basic ' +  btoa(localStorage.getItem('FreshDeskAPIKey')))});    
      
    }

 // Skip global loader for specific endpoints
    const skipLoader = request.url.includes('/api/cardholders/transactions/v2');
 
    if (!skipLoader) {
      // if ( !request.url.includes('alerts?CardKey=')) {
      this.requests.push(request);
      this.loadingService.isLoading.next(true);
      // }
    }

    return next
      .handle(request)
      .pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) { 
            // console.log('[Api Response]=>', event); 
          }
          return event;
        }),
        catchError((response) => {        
          if (response instanceof HttpErrorResponse && (!response.url.includes('quick-register/access')) && (!response.url.includes('transactions/high-risk/'))&& (!response.url.includes('download/document')) && (!response.url.includes('cip/access')) && (!response.url.includes('card/pinchange/commit' )) && (!response.url.includes('/verify/change-pin')) && (!response.url?.includes('/users/generate-otp/change-pin'))) {
            console.error('[Api Error Response]=>', response);            
              if (response.status === 401) {
                this.restService.generateNewIDMLogoutUrl();              
              }
              else{
                if (response.error && response.error.Messages) {
                  let message = '';
                  let responseMessageField=''
                  if(!response.url.includes('freshdesk.com')){
                    if(response.url.includes('dda/pdf/download') || response.url.includes('statements/download')){
                      this.translate.get('DASHBOARD.MYCARD.UnableToProcessTheRequest').subscribe(translatedValue =>{ message = translatedValue; });
                    }else{
                      message = MessageUtils.getErrorMessage(response);
                    }
                    const isSameAddressRedirect = response.url.includes('/cards/update-status') &&
                      response.error?.ResponseCode === 4122 &&
                      Array.isArray(response.error?.Messages) &&
                      response.error.Messages.some((m: { MessageOrField?: string }) => m.MessageOrField === 'SameAddress');

                    if (!response.url.includes('push-notifications/register') && !response.url.includes('transfer-funds') && !response.url.includes('accounts/create') && !response.url.includes('reset-password') && !response.url.includes('validate-ssn') && !response.url.includes('ssn/validate') && !response.url.includes('users/phoneNumbers/verify-otp') && !isSameAddressRedirect) {
                      this.showPopup(message);
                    }
                   if(response.url.includes('push-notifications/register')){
                    responseMessageField = MessageUtils.getErrorMessageCode(response);
                    if(responseMessageField == "MigratedToKudzu" || responseMessageField == "MigrationInProgress"){
                      this.openSmioneLoginRestrictModal()
                    }
                   } 
                  }
                }else{ 
                  let message = response.statusText;
                  this.showPopup(message);
                }
              }
          }
          return throwError(response);
        }),

        finalize(() => {
          // if ( !request.url.includes('alerts?CardKey=')) {
            this.removeRequest(request);
          // }
        })
      );
  }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) { this.requests.splice(i, 1); }
    this.loadingService.isLoading.next(this.requests.length > 0);
  }

  showPopup(data){
    this.dialog.open(ErrorModalComponent, {
      disableClose : false,
      data : { message : data } 
    });
  }

  openSmioneLoginRestrictModal(): void {
    const modalPanelClass = 'smione-intro-modal-alternate';
    this.dialog.open(SmioneIntroScreensComponent, {
        disableClose: true,
        panelClass: modalPanelClass,
        data: {
            showAlternateIntroPop: this.showAlternateIntroPopVal,
            isSkipUpgradeKudzu: false,
            smioneLoginRestrictmodalTrue: this.smioneLoginRestrictmodalTrue 
        }
    });
}


}
